import { useState, useEffect } from "react";

// ─────────────────────────────────────────────
// ZENITH DARK MODE TOKENS
// ─────────────────────────────────────────────
export const LIGHT = {
  primary:                "#55624d",
  primaryFixed:           "#d9e7cd",
  primaryFixedDim:        "#bdcbb2",
  onPrimary:              "#ffffff",
  surface:                "#f8faf3",
  surfaceContainer:       "#ecefe8",
  surfaceContainerLow:    "#f2f4ed",
  surfaceContainerLowest: "#ffffff",
  surfaceContainerHigh:   "#e7e9e2",
  onSurface:              "#191c18",
  onSurfaceVariant:       "#444841",
  secondary:              "#755754",
  secondaryContainer:     "#fed7d2",
  onSecondaryContainer:   "#795b58",
  outline:                "#757870",
  outlineVariant:         "#c5c8be",
  error:                  "#ba1a1a",
  errorContainer:         "#ffdad6",
  inverseSurface:         "#2e312d",
  inverseOnSurface:       "#eff2ea",
};

export const DARK = {
  primary:                "#bdcbb2",
  primaryFixed:           "#2a3626",
  primaryFixedDim:        "#3a4a35",
  onPrimary:              "#273422",
  surface:                "#111411",
  surfaceContainer:       "#1d201c",
  surfaceContainerLow:    "#191c18",
  surfaceContainerLowest: "#0c0f0b",
  surfaceContainerHigh:   "#272a25",
  onSurface:              "#e2e3db",
  onSurfaceVariant:       "#c4c8be",
  secondary:              "#e7bdb9",
  secondaryContainer:     "#3a1f1d",
  onSecondaryContainer:   "#e7bdb9",
  outline:                "#8e9189",
  outlineVariant:         "#444841",
  error:                  "#ffb4ab",
  errorContainer:         "#93000a",
  inverseSurface:         "#e2e3db",
  inverseOnSurface:       "#2e312d",
};

// ─────────────────────────────────────────────
// CSS VARIABLEN SETZEN
// ─────────────────────────────────────────────
function applyTheme(tokens) {
  const root = document.documentElement;
  Object.entries(tokens).forEach(([key, value]) => {
    // camelCase → --kebab-case
    const cssVar = "--z-" + key.replace(/([A-Z])/g, "-$1").toLowerCase();
    root.style.setProperty(cssVar, value);
  });
  root.style.setProperty("color-scheme", tokens === DARK ? "dark" : "light");
}

// ─────────────────────────────────────────────
// HOOK
// ─────────────────────────────────────────────
export function useDarkMode() {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem("habitOS_darkMode");
    if (saved !== null) return saved === "true";
    // System-Präferenz als Fallback
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  useEffect(() => {
    applyTheme(isDark ? DARK : LIGHT);
    localStorage.setItem("habitOS_darkMode", String(isDark));
    // Meta theme-color updaten
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", isDark ? DARK.surface : LIGHT.surface);
  }, [isDark]);

  // System-Präferenz beobachten
  useEffect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = (e) => {
      const saved = localStorage.getItem("habitOS_darkMode");
      if (saved === null) setIsDark(e.matches);
    };
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  const toggle = () => setIsDark(prev => !prev);

  return { isDark, toggle, tokens: isDark ? DARK : LIGHT };
}

// ─────────────────────────────────────────────
// HELPER: aktuelles Token-Set (für Komponenten
// die keinen Prop bekommen)
// ─────────────────────────────────────────────
export function getTokens() {
  const isDark = localStorage.getItem("habitOS_darkMode") === "true"
    || (localStorage.getItem("habitOS_darkMode") === null
        && window.matchMedia("(prefers-color-scheme: dark)").matches);
  return isDark ? DARK : LIGHT;
}